import React from 'react';
import { Field, ErrorMessage } from 'formik';

const Step4 = ({ formData }) => (
    <div style={{ width: '100%', maxWidth: '400px' }}>
        <p style={{ fontStyle: 'italic', textAlign: 'justify' }}>Just in case something goes wrong, let us know who should we reach out to</p>

        <div className={"main-descriptions user-title"} style={{ width: '100%', marginTop: '20px' }}>
            Emergency Contact Information
        </div>

        <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label htmlFor="emergencyName">Person's Name</label>
            <Field name="emergencyName" placeholder="Jane Sardine" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="emergencyName" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <label htmlFor="emergencyRelationship">Relationship</label>
            <Field name="emergencyRelationship" placeholder="Mother" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="emergencyRelationship" component="div" style={{ color: '#CD3E3D' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}>
            <label htmlFor="emergencyPhone">Person's Phone Number</label>
            <Field name="emergencyPhone" placeholder="123456789" className='login-input' style={{ marginTop: '5px' }} />
            <ErrorMessage name="emergencyPhone" component="div" style={{ color: '#CD3E3D' }} />
        </div>

    </div>
);

export default Step4;
